import React from 'react';
const tomes = [{
  number: '01',
  title: 'El Despertar Neuro-Sensorial',
  desc: 'De 0 a 6 meses. Actividades sensoriales y rutinas de estimulación para el primer semestre.'
}, {
  number: '02',
  title: 'El Conquistador de Espacios',
  desc: 'De 6 a 12 meses. Gateo, exploración y coordinación motriz.'
}, {
  number: '03',
  title: 'La Revolución del Lenguaje y los Primeros Pasos',
  desc: 'De 12 a 18 meses. Primeras palabras, comunicación y marcha independiente.'
}, {
  number: '04',
  title: 'Autonomía y Conexión Sináptica',
  desc: 'De 18 a 24 meses. Juego simbólico, regulación emocional e independencia.'
}, {
  number: '05',
  title: 'Pensamiento Lógico y Socialización',
  desc: 'De 24 a 30 meses. Resolución de problemas y primeras normas sociales.'
}, {
  number: '06',
  title: 'El Niño Pre-escolar: Potencial Académico',
  desc: 'De 30 a 36 meses. Atención, memoria y habilidades pre-académicas.'
}];
const includes = ['Actividades listas por área y por mes', 'Semáforo de alertas neurológicas', 'Checklists de hitos del desarrollo', 'Registro de progreso mensual', 'Protocolos de estimulación por área', 'Material explicativo para aplicar en casa'];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(240,253,244) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-356">
      <div className="mx-auto max-w-4xl" data-id="element-357">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-358">
          Lo que <span className="text-green-700" data-id="element-359">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-360">
          6 tomos · 360 páginas · Todo listo para aplicar hoy con tu hijo
        </p>

        {/* Tomos */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-361">
          <div className="bg-green-700 px-5 py-2.5" data-id="element-362">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-363">
              👶 LOS 6 TOMOS — Sistema Completo de Estimulación Temprana 0 a 36 Meses
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-364">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-365">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-366">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0" data-id="element-367">
                  <span className="block text-sm font-black text-gray-900" data-id="element-368">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-369">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold text-green-700 bg-green-700/5 border border-green-700/20 rounded-full px-2 py-0.5" data-id="element-370">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm" data-id="element-371">
          <div className="bg-green-700/5 border-b border-green-700/20 px-5 py-2.5" data-id="element-372">
            <h3 className="text-sm font-black text-green-700 m-0" data-id="element-373">
              Cada tomo incluye:
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-374">
            {includes.map((item, i) => <div key={item} className={`flex items-start gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''}`} data-id="element-375">
                <span className="shrink-0 text-green-700 font-bold text-sm mt-0.5" data-id="element-376">✅</span>
                <span className="text-xs text-gray-700 leading-5" data-id="element-377">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}